export default __webpack_public_path__ + "static/studyoffice-lounge2-25c293e38f945b4b19f07c029f4b4c4c.jpg";